import React from 'react';
import { Img } from 'react-image';

interface StorylineDilemmaNewOptionCardProps {
  onClick: () => void;
}

const StorylineDilemmaNewOptionCard: React.FC<
  StorylineDilemmaNewOptionCardProps
> = ({ onClick }) => {
  return (
    <div
      className="
          flex flex-col justify-center w-full text-sm rounded-xl max-md:mt-3 cursor-pointer bg-gray-50 border border-gray-200
          max-lg:mt-0
          sm:grow
        "
    >
      <div
        className={`
              flex overflow-hidden relative flex-col w-full h-[180px]
          `}
        onClick={onClick}
      >
        <div className="absolute inset-0">
          <Img
            src={[require('../../assets/icons/write.svg')]}
            alt="Create Your Choice"
            className={`object-cover absolute inset-0 rounded-xl m-auto mt-[32px] w-[60px]
                max-sm:mt-[22px]
              `}
          />
        </div>
        <div
          className="absolute flex flex-col top-0 left-0 w-full h-full text-black bg-transparent rounded-xl"
          style={{
            backgroundSize: '100% 80%',
            backgroundPosition: 'bottom',
            backgroundRepeat: 'no-repeat',
          }}
        >
          <div className="px-3 pb-2 mt-auto xl:min-h-20">
            <div
              className="
                  relative mb-auto text-center text-base font-medium text-gray-800 max-md:mt-5 max-md:mr-2.5
                "
            >
              Create Your Choice
            </div>
            <div className="relative mt-1 text-center opacity-50 max-md:mr-2.5 line-clamp-2">
              Add your own unique choice
            </div>
          </div>
        </div>
      </div>
    </div>
  );
};

export default StorylineDilemmaNewOptionCard;
